export enum Locale {
  FR_FR = 'fr_FR',
  EN_GB = 'en_GB',
  ES_ES = 'es_ES',
  IT_IT = 'it_IT',
  PT_PT = 'pt_PT',
  DE_DE = 'de_DE',
  EN_US = 'en_US',
  ES_MX = 'es_MX',
}
